import { useAuth } from "../hooks/useAuth";
import { SidebarDrawerProvider } from "contexts/SidebarDrawerContext";
import HomeInterBrasil from "pages/InterBrasil";
import Contatos from "pages/InterBrasil/Contatos";
import Contratos from "pages/InterBrasil/Contratos";
import Documentos from "pages/InterBrasil/Documentos";
import PessoasJuridicas from "pages/InterBrasil/PessoasJuridicas";
import Operadoras from "pages/InterBrasil/Operadoras";
import Servicos from "pages/InterBrasil/Servicos";
import Usuarios from "pages/InterBrasil/Usuarios";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ServicosPortal from "pages/Portal/Servicos";
import DocumentosPortal from "pages/Portal/Documentos";
import ContatosPortal from "pages/Portal/Contatos";
import Suporte from "pages/Portal/Suporte";
import PerfilAdmin from "pages/InterBrasil/Perfil";
import PerfilPortal from "pages/Portal/Perfil";
import CoparticipacaoPortal from "pages/Portal/Operadoras/Coparticipacao";
import CoparticipacaoAdmin from "pages/InterBrasil/Operadoras/Coparticipacao";
import Cobranca from "pages/InterBrasil/PessoasJuridicas/cobranca";
import CobrancaPortal from "pages/Portal/PessoasJuridicas/cobranca";
import PainelControlePortal from "pages/Portal/PessoasJuridicas/painel";
import PainelControleInter from "pages/InterBrasil/PessoasJuridicas/Painel";
import RepasseTaxas from "pages/InterBrasil/PessoasJuridicas/repasseTaxas";
import RepasseTaxasPortal from "pages/Portal/PessoasJuridicas/repasseTaxas";
import Utilizacao from "pages/InterBrasil/Operadoras/Utilizacao";
import UtilizacaoPortal from "pages/Portal/Operadoras/Utilizacao";
import PainelControleOperadoraInter from "pages/InterBrasil/Operadoras/Painel";
import PainelControleOperadoraPortal from "pages/Portal/Operadoras/Painel";

export default function Index() {
  const {
    user,
    qtdContratosCobranca,
    qtdContratosRepasseTaxas,
    qtdContratosUtilizacao,
    qtdContratosCoparticipacao,
  } = useAuth();

  return (
    <BrowserRouter>
      <SidebarDrawerProvider>
        <Routes>
          {user?.role.name === "Admin" ? (
            <>
              <Route path="/" element={<HomeInterBrasil />} />
              <Route path="*" element={<HomeInterBrasil />} />
              <Route
                path="/interbrasil/operadoras/painel-de-controle"
                element={<PainelControleOperadoraInter />}
              />
              <Route
                path="/interbrasil/pessoas-juridicas/painel-de-controle"
                element={<PainelControleInter />}
              />
              <Route path="/interbrasil/perfil" element={<PerfilAdmin />} />
              <Route path="/interbrasil/operadoras" element={<Operadoras />} />
              <Route
                path="/interbrasil/pessoas-juridicas"
                element={<PessoasJuridicas />}
              />
              <Route path="/interbrasil/contratos" element={<Contratos />} />
              <Route path="/interbrasil/usuarios" element={<Usuarios />} />
              <Route path="/interbrasil/contatos" element={<Contatos />} />
              <Route path="/interbrasil/servicos" element={<Servicos />} />
              <Route
                path="/interbrasil/operadoras/coparticipacao"
                element={<CoparticipacaoAdmin />}
              />
              <Route
                path="/interbrasil/operadoras/utilizacao"
                element={<Utilizacao />}
              />
              <Route path="/interbrasil/documentos" element={<Documentos />} />
              <Route
                path="/interbrasil/pessoas-juridicas/cobranca"
                element={<Cobranca />}
              />
              <Route
                path="/interbrasil/pessoas-juridicas/repasse-taxas"
                element={<RepasseTaxas />}
              />
            </>
          ) : (
            user &&
            (user.operadora || user.entidade) && (
              <>
                {user.fl_primeiro_acesso ? (
                  <>
                    <Route path="/" element={<PerfilPortal />} />
                    <Route path="/portal/perfil" element={<PerfilPortal />} />
                  </>
                ) : (
                  <>
                    <Route path="/" element={<ServicosPortal />} />
                    <Route path="*" element={<ServicosPortal />} />
                    <Route
                      path="/portal/servicos"
                      element={<ServicosPortal />}
                    />
                    {user.operadora &&
                      (qtdContratosCoparticipacao > 0 ||
                        qtdContratosUtilizacao > 0) && (
                        <Route
                          path="/portal/operadoras/painel-de-controle"
                          element={<PainelControleOperadoraPortal />}
                        />
                      )}
                    {qtdContratosCoparticipacao > 0 && user.operadora && (
                      <Route
                        path="/portal/operadoras/coparticipacao"
                        element={<CoparticipacaoPortal />}
                      />
                    )}
                    {user.operadora && qtdContratosUtilizacao && (
                      <Route
                        path="/portal/operadoras/utilizacao"
                        element={<UtilizacaoPortal />}
                      />
                    )}
                    {user.entidade &&
                      (qtdContratosCobranca > 0 ||
                        qtdContratosRepasseTaxas > 0) && (
                        <Route
                          path="/portal/pessoas-juridicas/painel-de-controle"
                          element={<PainelControlePortal />}
                        />
                      )}
                    {user.entidade && qtdContratosCobranca > 0 && (
                      <>
                        <Route
                          path="/portal/pessoas-juridicas/cobranca"
                          element={<CobrancaPortal />}
                        />
                      </>
                    )}
                    {user.entidade && qtdContratosRepasseTaxas > 0 && (
                      <>
                        <Route
                          path="/portal/pessoas-juridicas/repasse-taxas"
                          element={<RepasseTaxasPortal />}
                        />
                      </>
                    )}
                    <Route
                      path="/portal/documentos"
                      element={<DocumentosPortal />}
                    />
                    <Route
                      path="/portal/contatos"
                      element={<ContatosPortal />}
                    />
                    <Route path="/portal/suporte" element={<Suporte />} />
                    <Route path="/portal/perfil" element={<PerfilPortal />} />
                  </>
                )}
              </>
            )
          )}
        </Routes>
      </SidebarDrawerProvider>
    </BrowserRouter>
  );
}
